import React from "react";
import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { tools } from "@/data/publicFoundation";
import { useTranslation } from "@/i18n";
import { getCalculatorToolContent, getToolPageCopy } from "@/components/public/calculators/calculatorTranslations";
import NauticalToolCalculator from "@/components/public/calculators/NauticalToolCalculator";
import CalculatorExplanation from "@/components/public/calculators/CalculatorExplanation";
import DistanceCalculatorSeoBlock from "@/components/public/calculators/DistanceCalculatorSeoBlock";
import PublicBreadcrumbs from "@/components/public/PublicBreadcrumbs";
import AdSenseApprovalEditorialBlock from "@/components/public/AdSenseApprovalEditorialBlock";

export default function ToolPage() {
  const { lang = "en", toolSlug = "fuel-calculator" } = useParams();
  const { t } = useTranslation();
  const tool = tools.find((item) => item.slug === toolSlug) || tools[0];
  const homeCopy = t("home", { defaultValue: {} });
  const toolPageCopy = getToolPageCopy(lang);
  const localizedTool = { ...tool, ...(homeCopy.tools?.[tool.slug] || {}), ...getCalculatorToolContent(tool.slug, lang) };

  return (
    <div className="maritime-container py-8 md:py-14">
      <PublicBreadcrumbs
        items={[
          { label: toolPageCopy.home, href: `/${lang}` },
          { label: toolPageCopy.calculatorsCrumb, href: `/${lang}/sailing-calculators` },
          { label: localizedTool.title },
        ]}
      />

      <NauticalToolCalculator tool={localizedTool} lang={lang} />
      <AdSenseApprovalEditorialBlock pageKey="tools" lang={lang} />
      <CalculatorExplanation tool={localizedTool} lang={lang} />
      {toolSlug === "distance-calculator" && <DistanceCalculatorSeoBlock lang={lang} />}

      <section className="mt-8 grid gap-4 lg:grid-cols-[1fr_18rem]">
        <div className="rounded-3xl border border-border bg-muted/35 p-6">
          <h2 className="text-2xl font-black">{toolPageCopy.planningNote}</h2>
          <p className="mt-2 text-muted-foreground">{toolPageCopy.planningText}</p>
        </div>
        <div className="rounded-3xl border border-border bg-card p-6">
          <h2 className="text-xl font-black">{toolPageCopy.relatedGuides}</h2>
          <Link className="mt-3 block font-bold text-primary" to={`/${lang}/learn`}>{toolPageCopy.coastalGuide}</Link>
          <Link className="mt-2 block font-bold text-primary" to={`/${lang}/weather`}>{toolPageCopy.weatherGuide}</Link>
          <Button asChild className="mt-5 w-full"><Link to={`/${lang}/sailing-calculators`}>{toolPageCopy.viewAll}</Link></Button>
        </div>
      </section>

    </div>
  );
}